import { useConstantValueInvariant } from "@contember/react-utils";
import { useMemo } from "react";
function useEntityListSubTreeParameters(qualifiedEntityList) {
  useConstantValueInvariant(typeof qualifiedEntityList);
  if (typeof qualifiedEntityList === "string") {
    return qualifiedEntityList;
  }
  useConstantValueInvariant(
    qualifiedEntityList.isCreating,
    `EntityListSubTree: cannot alternate the 'isCreating' value.`
  );
  useConstantValueInvariant(
    typeof qualifiedEntityList.entities,
    `EntityListSubTree: cannot alternate the 'entities' value.`
  );
  if (qualifiedEntityList.isCreating) {
    const entities2 = qualifiedEntityList.entities;
    if (typeof entities2 === "string") {
      return useMemo(
        () => ({
          isCreating: true,
          entities: entities2
        }),
        [entities2]
      );
    }
    return useMemo(
      () => ({
        isCreating: true,
        entities: { entityName: entities2.entityName }
      }),
      [entities2.entityName]
    );
  }
  const entities = qualifiedEntityList.entities;
  if (typeof entities === "string") {
    return useMemo(
      () => ({
        entities,
        orderBy: qualifiedEntityList.orderBy,
        offset: qualifiedEntityList.offset,
        limit: qualifiedEntityList.limit
      }),
      [entities, qualifiedEntityList.limit, qualifiedEntityList.offset, qualifiedEntityList.orderBy]
    );
  }
  return useMemo(
    () => ({
      entities: {
        entityName: entities.entityName,
        filter: entities.filter
      },
      orderBy: qualifiedEntityList.orderBy,
      offset: qualifiedEntityList.offset,
      limit: qualifiedEntityList.limit
    }),
    [
      entities.entityName,
      entities.filter,
      qualifiedEntityList.limit,
      qualifiedEntityList.offset,
      qualifiedEntityList.orderBy
    ]
  );
}
export {
  useEntityListSubTreeParameters
};
//# sourceMappingURL=useEntityListSubTreeParameters.js.map
